// Dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'
import { pageGutter } from 'styles/gutter'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eceeee;
  padding: 24px;

  ${MediaQueries.medium} {
    ${pageGutter}
  }
`

export const Content = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 40px;

  ${MediaQueries.notebook} {
    gap: 80px;
  }
`

export const BannerItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

export const BannerItemLabel = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #666b7b;
`

export const BannerItemListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #ced0dd;
  border-radius: 16px;

  > div:nth-child(2) {
    border-top: 1px solid #ced0dd;
  }
`

export const BannerItemListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 24px;
`

export const BannerItemListItemIcon = styled.img`
  display: block;
`

export const BannerItemListItemLabel = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #666b7b;
`
